import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import LoadingSpinner from '../atoms/loading';
import Scrollbars from "react-custom-scrollbars";
import MsxIcons from '../features/msx-icons';
import I10n from '../features/i10n';
import { SeChip } from '@se/web-ui-react';
import { Fragment } from 'react';
import { PRIMARY_COLOR } from '../color-constants';

const Container = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: 10px;
  @media (max-width: 800px) {
    position: absolute;
    top: 0;
    left: 0;
    ${props => props.isMobileOpen ? 'width: 100%; padding-right: 0px;' : 'width: 0px;'}
    height: calc(100% + 16px);
    z-index: 11;
    transition: width 0.3s;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction : row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const Title = styled.h3`
  display: inline-flex;
  align-items: center;
  margin: 0px;
  font-size: 14px !important;
  line-height: 36px !important;
  font-weight: bold;
  @media (max-width: 800px) {
    display: none;
  }
`;

const MobileTitle = styled.h3`
  display: none;
  margin: 0px;
  font-size: 14px !important;
  line-height: 36px !important;
  font-weight: bold;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  @media (max-width: 800px) {
    display: inline-flex;
  }
`;

const ContentWrapper = styled.div`
  background-color: white;
  border-radius: 10px;
  padding-left: 10px;
  margin-bottom: 10px;
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  @media (max-width: 800px) {
    overflow: hidden;
    height: 100%;
    ${props => props.isMobileOpen ? 'display: flex; padding-right: 20px; padding-top: 5px; margin-left: -5px' : 'display: none;'}  }
`;

const MobileCloseIcon = styled.div`
  display: inline-block;
  margin-left: 4px;
  display: none;
  cursor: pointer;
  background-color: ${PRIMARY_COLOR};
  background-color: var(--se-secondary, ${PRIMARY_COLOR});
  color: white;
  color: var(--se-secondary-contrast, white);
  border-radius: 50%;
  @media (max-width: 800px) {
    display: flex;
  }
  width: 32px;
  height: 32px;
  box-sizing: content-box;
  justify-content: center;
  align-items: center;
`;

const PaddingWrapper = styled.div`
  padding-right: 15px;
  padding-bottom: 10px;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #979797;
  padding: 10px 15px;
  border-radius: 10px;
  user-select: none;
`;

const QuestionLabel = styled.h5`
  margin: 0;
  color: #333333;
  font-size: 12px !important;
  line-height: normal !important;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const AnswersWrapper = styled.div`
`;

class PacdriveOptions extends React.Component {

  static propTypes = {
    options: PropTypes.object,
    isLoading: PropTypes.bool,
    onAnswerChanged: PropTypes.func,
    mobileFilterOpened: PropTypes.bool,
    toggleMobileFilter: PropTypes.func,
  }

  renderOptions = () => {
    return (
      <AnswersWrapper>
        {
          Object.keys(this.props.options).sort()
            .map((key, index) => {
              const category = this.props.options[key];
              return (
                <Fragment key={key}>
                  <QuestionLabel>{I10n.get(`screen.pacdrive_adjust.modal.category.${key.toLowerCase()}`)}</QuestionLabel>
                  {
                    Object.keys(category).sort().map((optKey, index) => {
                      const opt = category[optKey];
                      return (
                        <SeChip
                          style={{ display: 'flex' }}
                          key={index}
                          size="nano"
                          value={I10n.get(`screen.pacdrive_adjust.modal.${optKey.toLowerCase()}`)}
                          selected={opt.toggle === true}
                          onClick={() => {
                            this.props.onAnswerChanged(opt.nextRef);
                          }}>
                        </SeChip>
                      );
                    })
                  }
                </Fragment>
              );
            })
        }
      </AnswersWrapper>);
  }

  render = () => {
    return (
      <Container id='packdrive-option-container' isMobileOpen={this.props.mobileFilterOpened}>
        <ContentWrapper id='packdrive-option-contentWrapper' isMobileOpen={this.props.mobileFilterOpened}>
          <TitleWrapper>
            <Title>
              {I10n.get('screen.pacdrive_adjust.modal.options.title')}
            </Title>
            <MobileTitle>
              {I10n.get('screen.head_device_selector_screen.plc.filters')}
            </MobileTitle>
            <MobileCloseIcon onClick={() => { this.props.toggleMobileFilter(false) }}>
              <MsxIcons name="left-arrow" size="nano"></MsxIcons>
            </MobileCloseIcon>
          </TitleWrapper>
          {this.props.isLoading && Object.keys(this.props.options).length > 0 ?
            <LoadingWrapper>
              <LoadingSpinner></LoadingSpinner>
            </LoadingWrapper>
            :
            <Scrollbars>
              <PaddingWrapper>
                <OptionsContainer>
                  {this.renderOptions()}
                </OptionsContainer>
              </PaddingWrapper>
            </Scrollbars>
          }
        </ContentWrapper>
      </Container>
    );
  }
}

export default PacdriveOptions;
